import React from 'react'
import { useArticlesCheck } from 'hooks/use-articles-check'

import Button from 'components/molecules/Button'
import NegativeStatus from 'components/molecules/NegativeStatus'
import GrayText from 'components/atoms/GrayText'

import { ManualArticlesFormItem } from './ManualArticlesFormItem'

const ManualArticlesForm: React.FC = () => {
  const { articlesCheck, items, options, isLoading, onChange, handleRemove, submitManual, isVisible } = useArticlesCheck()
  if (!isVisible) return null

  const foundNegatives = articlesCheck?.foundNegatives

  return (
    <div className="col-md-6 col-sm-12 p-0" style={{ margin: '8px 0' }}>
      {foundNegatives ? (
        <div style={{ marginBottom: 'min(12px, 1vw)' }}>
          <GrayText text="Негатив из справочника (по заявке):" />
          <NegativeStatus data={foundNegatives} />
        </div>
      ) : null}
      {items.map((item) => (
        <React.Fragment key={item.id}>
          <ManualArticlesFormItem item={item} onChange={onChange} handleRemove={handleRemove} options={options} disabled={isLoading} />
        </React.Fragment>
      ))}
      <Button onClick={submitManual} content="Сохранить статьи" disabled={isLoading} isLoading={isLoading} className="col-12 col-md-4" />
    </div>
  )
}

export default ManualArticlesForm
